import { render, staticRenderFns } from "./b-number-input.vue?vue&type=template&id=3d92734f&scoped=true"
import script from "./b-number-input.vue?vue&type=script&lang=js"
export * from "./b-number-input.vue?vue&type=script&lang=js"
import style0 from "./b-number-input.vue?vue&type=style&index=0&id=3d92734f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d92734f",
  null
  
)

export default component.exports